import axios, { AxiosResponse, AxiosError, AxiosInstance } from "axios";

class ApiConnector {
    private readonly axiosInstance: AxiosInstance;

    constructor(baseURL: string, token: string) {
        this.axiosInstance = axios.create({
            baseURL,
        });
        this.axiosInstance.interceptors.request.use((config) => {
            config.headers.Token = `Bearer ${token}`;
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        });
    }

    private async request<T>(
        method: string,
        endpoint: string,
        data?: any,
        additionalHeaders?: Record<string, string>
    ): Promise<T> {
        try {
            const response: AxiosResponse<T> = await this.axiosInstance({
                method,
                url: endpoint,
                data,
                headers: additionalHeaders,
            });
            return response.data;
        } catch (error: any) {
            throw (error as AxiosError).response?.data || error.message;
        }
    }
    private async requestBlob<T>(
        method: string,
        endpoint: string,
        data?: any,
        additionalHeaders?: Record<string, string>
    ): Promise<T> {
        try {
            const response: AxiosResponse<T> = await this.axiosInstance({
                method,
                url: endpoint,
                data,
                responseType: 'blob',
                headers: additionalHeaders,
            });
            return response.data;
        } catch (error: any) {
            throw (error as AxiosError).response?.data || error.message;
        }
    }

    public async getBlob<T>(endpoint: string, additionalHeaders?: Record<string, string>): Promise<T> {
        return await this.requestBlob<T>("GET", endpoint, undefined, additionalHeaders);
    }

    public async get<T>(endpoint: string, additionalHeaders?: Record<string, string>): Promise<T> {
        return await this.request<T>("GET", endpoint, undefined, additionalHeaders);
    }

    public async put<T>(endpoint: string, data: any, additionalHeaders?: Record<string, string>): Promise<T> {
        return await this.request<T>("PUT", endpoint, data, additionalHeaders);
    }

    public async post<T>(endpoint: string, data?: any, additionalHeaders?: Record<string, string>): Promise<T> {
        return await this.request<T>("POST", endpoint, data, additionalHeaders);
    }

    public async delete<T>(endpoint: string, additionalHeaders?: Record<string, string>): Promise<T> {
        return await this.request<T>("DELETE", endpoint, undefined, additionalHeaders);
    }
}

export default ApiConnector;
